require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-diversityatrisk.json") })
        }
      }, "path---insights-diversityatrisk");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-diversityatrisk!./.cache/json/insights-diversityatrisk.json
// module id = 1117
// module chunks = 231608221292675